import { render } from "./GallerySlider.vue?vue&type=template&id=013b69e6&scoped=true"
import script from "./GallerySlider.vue?vue&type=script&lang=js"
export * from "./GallerySlider.vue?vue&type=script&lang=js"

import "./GallerySlider.vue?vue&type=style&index=0&id=013b69e6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013b69e6"],['__file',"src/scripts/sections/modules/gallery/GallerySlider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "013b69e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('013b69e6', __exports__)) {
    api.reload('013b69e6', __exports__)
  }
  
  module.hot.accept("./GallerySlider.vue?vue&type=template&id=013b69e6&scoped=true", () => {
    api.rerender('013b69e6', render)
  })

}


export default __exports__